// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.freetrial-modal {
  display: flex;
  flex-direction: column;
  width: 25vw;
  height: 53vh;
  overflow-y: auto;
  border-radius: 2rem;
  background-color: white;
}
.freetrial-modal .header {
  height: 150px;
  flex-shrink: 0;
}
.freetrial-modal .header .close-icon {
  color: white;
  cursor: pointer;
  position: absolute;
  right: 15px;
  top: 15px;
  z-index: 1000;
}
.freetrial-modal .header .curveTop-1 {
  position: relative;
  bottom: 0px;
}
.freetrial-modal .header .curveTop-2 {
  position: relative;
  bottom: 140px;
}
.freetrial-modal .header .curveTop-3 {
  position: relative;
  bottom: 280px;
}
.freetrial-modal .body {
  flex: 1;
}
.freetrial-modal .footer {
  height: 150px;
  flex-shrink: 0;
}
.freetrial-modal .footer .curveBottom-1 {
  position: relative;
  bottom: 0px;
}
.freetrial-modal .footer .curveBottom-2 {
  position: relative;
  bottom: 175px;
}
.freetrial-modal .footer .curveBottom-3 {
  position: relative;
  bottom: 350px;
}

::ng-deep .p-dialog .p-dialog-header {
  display: none;
}

::ng-deep .p-dialog .p-dialog-content {
  padding: 0;
  background-color: transparent;
}`, "",{"version":3,"sources":["webpack://./src/app/main/apps/components/freetrial-expiration/freetrial-expiration.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AACJ;AACI;EAEI,aAAA;EACA,cAAA;AAAR;AAEQ;EACI,YAAA;EACA,eAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,aAAA;AAAZ;AAIQ;EACI,kBAAA;EACA,WAAA;AAFZ;AAKQ;EACI,kBAAA;EACA,aAAA;AAHZ;AAMQ;EACI,kBAAA;EACA,aAAA;AAJZ;AAQI;EAEI,OAAA;AAPR;AAUI;EAEI,aAAA;EACA,cAAA;AATR;AAWQ;EACI,kBAAA;EACA,WAAA;AATZ;AAYQ;EACI,kBAAA;EACA,aAAA;AAVZ;AAaQ;EACI,kBAAA;EACA,aAAA;AAXZ;;AAgBA;EACI,aAAA;AAbJ;;AAgBA;EACI,UAAA;EACA,6BAAA;AAbJ","sourcesContent":[".freetrial-modal {\n    display: flex;\n    flex-direction: column;\n    width: 25vw;\n    height: 53vh;\n    overflow-y: auto;\n    border-radius: 2rem;\n    background-color: white;\n\n    .header {\n        // background-color: red;\n        height: 150px;\n        flex-shrink: 0;\n\n        .close-icon {\n            color: white;\n            cursor: pointer;\n            position: absolute;\n            right: 15px;\n            top: 15px;\n            z-index: 1000;\n            ;\n        }\n\n        .curveTop-1 {\n            position: relative;\n            bottom: 0px;\n        }\n\n        .curveTop-2 {\n            position: relative;\n            bottom: 140px;\n        }\n\n        .curveTop-3 {\n            position: relative;\n            bottom: 280px;\n        }\n    }\n\n    .body {\n        // background-color: yellow;\n        flex: 1;\n    }\n\n    .footer {\n        // background-color: green;\n        height: 150px;\n        flex-shrink: 0;\n\n        .curveBottom-1 {\n            position: relative;\n            bottom: 0px;\n        }\n\n        .curveBottom-2 {\n            position: relative;\n            bottom: 175px;\n        }\n\n        .curveBottom-3 {\n            position: relative;\n            bottom: 350px;\n        }\n    }\n}\n\n::ng-deep .p-dialog .p-dialog-header {\n    display: none;\n}\n\n::ng-deep .p-dialog .p-dialog-content {\n    padding: 0;\n    background-color: transparent;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
